<template>
  <div :class="{card: !embedded}" :style="$rootForm ? {} : {'min-width': '40vw'}">
    <form class="form-horizontal">
      <div v-if="heading || !embedded" :class="{'card-header': !embedded, clearfix: true}">
        <div v-if="!embedded" style="float: right">
          <button type="button" class="btn"
                  :title="i18n.fr('action.undo')" :disabled="processing"
                  @click="undo"><i class="ti-back-right"></i>
            {{i18n.fr('action.undo')}}
          </button>
          <button type="button" class="btn"
                  :title="i18n.fr('action.reload')" :disabled="processing"
                  @click="reload"><i class="ti-reload" :class="{'ti-spin': loading}"></i>
            {{i18n.fr('action.reload')}}
          </button>
        </div>
        <h4 v-if="heading" class="card-title">{{heading}}</h4>
      </div>
      <!--<div v-if="loading" :class="{'card-content': !embedded}">-->
      <!--<h3 style="text-align: center" v-html="i18n.f('html.loading')"></h3>-->
      <!--</div>-->
      <div v-loading="loading"
           :class="{'card-content': !embedded}"
           :element-loading-text="i18n.fr('loading')">
        <template v-if="currentModel">
          <template v-if="categorizedColumns.length == 1">
            <div class="form-group" v-for="col in displayColumns" :key="col.prop">
              <label class="col-md-2 control-label">{{col.label}}</label>
              <div class="col-md-10">
                <component ref="fields"
                           :is="col.component"
                           :name="col.prop"
                           :spec="col"
                           :model="currentModel"
                           :$parentForm="$parentForm || self"
                           :$rootForm="$rootForm || self"
                           :rootModel="rootModel || currentModel"
                           :readonly="readonly || col.readonly"></component>
                <p class="text-danger" v-if="validator.errors.has(col.prop)">
                  {{validator.errors.first(col.prop)}}
                </p>
              </div>
            </div>
          </template>
          <vue-tabs v-else-if="categorizedColumns.length > 1" @tab-change="tabChanged" ref="tabs">
            <v-tab v-for="x in categorizedColumns" :title="x.title" :id="x.key">
              <div class="form-group" v-for="col in x.columns" :key="col.prop">
                <label class="col-md-2 control-label">{{col.label}}</label>
                <div class="col-md-10 control-content">
                  <component ref="fields"
                             :is="col.component"
                             :name="col.prop"
                             :spec="col"
                             :model="currentModel"
                             :$parentForm="$parentForm || self"
                             :$rootForm="$rootForm || self"
                             :rootModel="rootModel || currentModel"
                             :readonly="readonly || col.readonly"></component>
                  <p class="text-danger" v-if="validator.errors.has(col.prop)">
                    {{validator.errors.first(col.prop)}}
                  </p>
                </div>
              </div>
            </v-tab>
          </vue-tabs>
        </template>
        <h3 v-else style="text-align: center" v-html="i18n.fr('html.not_found')"></h3>
      </div>
      <div v-if="!loading && currentModel && showActions && formActions" class="text-right"
           :class="{'card-footer': !embedded}">
        <i v-show="processing" class="ti-reload ti-spin" style="font-size: large;"></i>
        <template v-for="(act, i) in formActions">
          <button type="button" class="btn btn-fill btn-wd" :disabled="processing"
                  @click.prevent="handleAction(act, String(i))"
                  :class="act.class"><i v-show="processing === String(i)" class="ti-reload ti-spin"></i>
            {{act.label}}
          </button>&nbsp;
        </template>
      </div>
    </form>
  </div>
</template>

<style>
</style>

<script>
  import {find, get, set, map, every, filter, groupBy, cloneDeep, flatMap, isArray, findIndex} from 'lodash';
  import {Validator} from 'vee-validate';
  import {sanitizeModel, setField, getField} from 'src/schemas/utils';
  import i18n from 'src/i18n/index';
  import {parseError} from 'src/utils';
  import sweetalert from 'sweetalert2';

  export default {
    components: {},
    props: {
      heading: {type: String},
      schema: {type: [Object, Promise, Function], required: true},
      id: String,
      model: {},
      $parentForm: {},
      rootModel: {},
      $rootForm: {},
      readonly: Boolean,
      showActions: {type: Boolean, default: true},
      embedded: Boolean,
    },
    data() {
      return {
        schema_: null,
        currentModel: null,
        backupModel: null,
        validator: Validator.create(),
        loading: false,
        processing: false,
      };
    },
    computed: {
      self() {
        return this;
      },
      columns() {
        let temp = typeof this.schema_.columns === 'function'
          ? this.schema_.columns.call(this, this.currentModel, this.schema_, this.readonly)
          : this.schema_.columns;
        return temp || [];
      },
      displayColumns() {
        return filter(this.columns, x => !x.hidden && (!this.embedded || x.embed !== false));
      },
      categorizedColumns() {
        return _.chain(this.displayColumns)
          .flatMap(col => {
            if (col.cat == null) {
              return {col, cat: 'fields.cat.default'};
            } else {
              return isArray(col.cat) ? map(col.cat, cat => ({col, cat})) : {col, cat: col.cat};
            }
          })
          .groupBy('cat')
          .map((v, k) => ({key: k, title: i18n.fr(k), columns: map(v, x => x.col)}))
          .value();
      },
      formActions() {
        let temp = typeof this.schema_.formActions === 'function'
          ? this.schema_.formActions.call(this, this.currentModel, this.schema_, this.readonly)
          : this.schema_.formActions;
        return temp || [];
      },
    },
    watch: {
      schema() {
        this.currentModel = null;
        this.reload();
      },
      model() {
        this.reload();
      },
      id() {
        this.reload();
      },
    },
    mounted() {
      let p = this.reload();
      let self = this;
      if (!this.$parentForm) { // only for root form
        p.then(() => {
          setTimeout(() => { // $nextTick is not enough, need setTimeout to pass the vue render cycle
            if (self.$refs.tabs) {
              let idx = findIndex(self.categorizedColumns, x => x.key == self.$route.hash.substr(1));
              if (idx >= 0) {
                self.$refs.tabs.findTabAndActivate(idx);
              }
            }
          }, 0);
        });
      }
      document.body.addEventListener('keydown', this.keyEvent);
    },
    beforeDestroy() {
      document.body.removeEventListener('keydown', this.keyEvent);
    },
    methods: {
      keyEvent(e) {
        if (this.$rootForm == null && e.target == document.body) {
          for (let i = 0; i < this.formActions.length; ++i) {
            let act = this.formActions[i];
            if (typeof act.trigger === 'function' && act.trigger.call(this, e)) {
              this.handleAction(act, String(i));
              break;
            }
          }
        }
      },
      async reload() {
        this.loading = true;
        this.schema_ = await (typeof this.schema === 'function' ? this.schema.call(this) : this.schema);
        let self = this;
        let fn = async () => {
          let setModel = (x) => {
            this.backupModel = x;
            this.currentModel = cloneDeep(x);
          };
          this.validator = Validator.create();
          if (this.model) {
            this.currentModel = await sanitizeModel.call(self, this.model, this.columns);
          } else if (this.id != null) {
            this.processing = 'reload';
            let model = await this.schema_.read.call(self, this.id, this.schema_, this.columns);
            setModel(await sanitizeModel.call(self, model, this.columns));
          } else {
            // create new
            this.processing = 'reload';
            let init = {};
            for (let k in this.$route.query) {
              set(init, k, this.$route.query[k]);
            }
            setModel(await sanitizeModel.call(self, init, this.columns));
          }
        };
        try {
          await fn();
        } catch (err) {
          err = parseError(err);
          this.$notify({
            component: {template: i18n.fr('alert.html.cannot_fetch_item_$err', {err})},
            icon: 'ti-alert',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
          });
        }
        this.loading = false;
        this.processing = false;
      },
      undo() {
        if (this.backupModel) {
          this.processing = 'undo';
          this.currentModel = cloneDeep(this.backupModel);
          setTimeout(() => this.processing = false, 0);
        }
      },
      /**
       * @return {Promise.<Boolean>}
       */
      validate() {
        let p = [];
        let self = this;
        this.validator = Validator.create();
        for (let col of this.displayColumns) {
          if (col.validation) {
            this.validator.attach(col.prop, col.validation);
          } else if (typeof col.validator === 'function') {
            let key = JSON.stringify(col.prop);
            this.validator.extend(key, {
              getMessage(field, args, data) {
                return data;
              },
              validate(v, args) {
                let err = col.validator.apply(self, arguments);
                return {valid: !err, data: err};
              },
            });
            this.validator.attach(col.prop, key);
          }
        }
        let dict = {};
        for (let col of this.columns) {
          setField.call(this, dict, col, getField.call(this, this.currentModel, col));
        }
        p.push(this.validator.validateAll(dict));
        if (this.$refs.fields) {
          for (let f of this.$refs.fields) {
            if (typeof f.validate === 'function') {
              p.push(f.validate());
            }
          }
        }
        return Promise.all(p).then(valid => {
          return every(valid);
        });
      },
      handleAction(act, i) {
        let v;
        if (act.validation) {
          v = this.validate();
        } else {
          v = Promise.resolve(true);
        }
        v.then(isValid => {
          if (isValid) {
            let p = act.action.call(this, this.currentModel, this.schema_, this.columns);
            if (p && typeof p === 'object' && typeof p.then === 'function') {
              this.processing = i;
              p.then(reload => {
                this.processing = false;
                if (reload) {
                  if (this.embedded) {
                    (this.$rootForm || this.$parentForm || this).reload();
                  } else {
                    this.reload();
                  }
                }
              }).catch(err => {
                this.processing = false;
                sweetalert({
                  title: i18n.fr('alert.html.$err', {err: parseError(err)}),
                  html: err.err_details ? '<pre>' + JSON.stringify(err.err_details) + '</pre>' : null,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonText: i18n.fr('action.ok'),
                  confirmButtonClass: 'btn btn-info btn-fill',
                  buttonsStyling: false,
                });
              });
            }
          }
        });
      },
      tabChanged(idx, newTab) {
        this.$router.replace('#' + newTab.id);
      },
      findField(path) {
        return find(get(this.$refs, 'fields', []), x => x.name == path);
      },
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// SchemaBaseForm.vue?77a3313e